import React, { Suspense } from "react";

const RouteSuspense = ({ children, fallback = null }) => (
  <Suspense fallback={fallback}>{children}</Suspense>
);

export default RouteSuspense;
